export default "__VITE_ASSET__Dt53fQ3m__"